import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * A wrapper component for routes that require app_editor permissions
 * If the user does not have the app_editor role, they will be redirected to the courses page
 */
function EditorRoute({ children }) {
  const { currentUser, loading } = useAuth();

  // Show loading indicator while checking authentication status
  if (loading) {
    return (
      <div className="text-center p-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Checking permissions...</p>
      </div>
    );
  }

  // Check if user has app_editor role or higher
  const hasEditorPermission = currentUser?.roles?.some(role => 
    role.name === 'app_editor' || role.name === 'admin' || role.name === 'superadmin'
  ) || false;

  // If not an editor, redirect to courses with a message
  if (!hasEditorPermission) {
    // Try to navigate to a different route than / to avoid redirect loops
    return <Navigate to="/courses" replace state={{ error: "You don't have permission to access that page" }} />;
  }

  // If user has editor permissions, render the protected component
  return children;
}

export default EditorRoute; 